import { DatatableColumnHeader } from "@/components/datatable-column-header";
import { ColumnDef } from "@tanstack/react-table";

import { UnitWithKeyResults } from "../../models/unit-model";

import { DatatableRowActions } from "./row-actions";

export const columns: ColumnDef<UnitWithKeyResults>[] = [
  {
    id: "title",
    accessorKey: "title",
    enableHiding: false,
    header: ({ column }) => <DatatableColumnHeader column={column} title="Name" />,
  },
  {
    id: "symbol",
    accessorKey: "symbol",
    header: ({ column }) => <DatatableColumnHeader column={column} title="Symbol" />,
  },
  {
    id: "maßnahmen",
    accessorKey: "maßnahmen",
    header: ({ column }) => <DatatableColumnHeader column={column} title="Maßnahmen" />,
    cell: ({ row }) => {
      const keyResults = row.getValue("maßnahmen");
      const length = keyResults instanceof Array ? keyResults.length : 0;
      return <div className="">{length === 1 ? `${length} Maßnahme` : `${length} Maßnahmen`}</div>;
    },
  },
  {
    id: "actions",
    cell: ({ row }) => <DatatableRowActions row={row} />,
  },
];
